var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMugSaucer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 32H120C106.75 32 96 42.75 96 56V288C96 341 139 384 192 384H384C437 384 480 341 480 288H512C582.625 288 640 230.625 640 160S582.625 32 512 32ZM512 224H480V96H512C547.25 96 576 124.75 576 160S547.25 224 512 224ZM560 416H16C7.164 416 0 423.164 0 432C0 458.508 21.49 480 48 480H528C554.51 480 576 458.508 576 432C576 423.164 568.838 416 560 416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugSaucer);
export default __webpack_public_path__ + "static/media/mug-saucer.db2f77b204661172c9b69b5b9f284a13.svg";
export { ForwardRef as ReactComponent };